import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Typography } from '@emburse/ui-core';
import { BulkUploadCategorySingleDiff } from '@ReactComponents/BulkUploadCategorySingleDiff/BulkUploadCategorySingleDiff';
import { TeamBulkUploadSingleDiff } from '@ReactComponents/TeamBulkUploadSingleDiff';
export class BulkUploadWizardErrorDetails extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { errorDiffs, uploadType } = this.props;
        let Component;
        switch (uploadType) {
            case 'team': {
                Component = TeamBulkUploadSingleDiff;
                break;
            }
            case 'categories': {
                Component = BulkUploadCategorySingleDiff;
                break;
            }
        }
        const count = this.props.errorDiffs.reduce((errorCount, diff) => errorCount + Object.keys(diff.fieldErrorMap).length, 0);
        const details = errorDiffs.map((diff, i) => _jsx(Component, { diff: diff }, i));
        return (_jsxs("div", { children: [_jsxs(Typography, { children: ["We found ", _jsx("em", { children: count }), " errors in your csv"] }), _jsx("div", Object.assign({ className: "details" }, { children: details }))] }));
    }
}
